import axios from 'axios'
import API from '@/services/API/api'

export default async arrIds => {
    try {
        let response = await axios.post(API.GET_NEW_TOTALS, {
            sale_ids: arrIds,
        })
        return response.data
    } catch (error) {
        return error.response.data
    }
}
